import { render, staticRenderFns } from "./ledgerInvoice.vue?vue&type=template&id=3c830a47&scoped=true"
import script from "./ledgerInvoice.vue?vue&type=script&lang=js"
export * from "./ledgerInvoice.vue?vue&type=script&lang=js"
import style0 from "./ledgerInvoice.vue?vue&type=style&index=0&id=3c830a47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c830a47",
  null
  
)

export default component.exports